import GTMEventAction from '^enums/gtm/GTMEventAction';
import GTMEventCategory from '^enums/gtm/GTMEventCategory';

import gtmHelper from './gtmHelper';

export const emitChangeColorClick = (imageToken: string): void =>
  gtmHelper.emitEvent(GTMEventCategory.ColorIcon, GTMEventAction.Click, imageToken);
